module.exports = __webpack_public_path__ + "static/img/pay-seven.ed59644.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pay-seven.png
// module id = DAg0
// module chunks = 0